import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Footer from "./Footer";
import TopBar from "./TopBar";
import CookiesConsent from "src/component/CookiesConsent";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
  },
  MainLayout: {
    minHeight: "calc(100vh - 200px)",
    background: "white",
  },
}));

const MainLayout = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={classes.root}>
      <TopBar />
      <div
        style={
          history.location.pathname !== "/"
            ? { display: "block" }
            : { display: "none" }
        }
      ></div>

      <div className={classes.MainLayout}>{children}</div>
      {/* {window.location.pathname ==="/" && ( */}
      <Footer />

      {/* )} */}
      <CookiesConsent />
    </div>
  );
};

export default MainLayout;
